







import { defineComponent, PropType } from "@vue/composition-api";
import { useGetters, useMutations, useState } from "vuex-composition-helpers";
import { IShowAllConfig } from "../../models/config-interface";

export default defineComponent({
    name: 'ShowAll',
    props: {
        config: {
            type: Object as PropType<IShowAllConfig>,
            required: true
        }
    },
    setup: (props) => {
        const { setConfig } = useMutations('showAll', ['setConfig'])
        const { labels } = useGetters('showAll', ['labels'])
        const { updateSetting } = useMutations(['updateSetting'])
        const { settings } = useState(['settings'])

        setConfig(props.config)

        return {
            labels,
            settings,
            update: () => updateSetting(['showAll', !settings.value?.showAll])
        }
    }
})
